module.exports = __webpack_public_path__ + "img/laboratorio_4-3_682.d61d893e.jpg";